// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/carousel-fullwidth-item/carousel-fullwidth-item.component.scss
// module id = 422
// module chunks = 0